<template>
  <v-dialog
    v-model="active"
    persistent
    transition="dialog-bottom-transition"
    style="z-index: 2000"
    max-width="800"
    :retain-focus="false"
    :scrollable="true"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card
      class="text-center"
      :class="
        getTheme() == 'dark' ? 'outlined elevation-0' : 'flat elevation-0'
      "
      :style="getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'"
    >
      <v-card-title
        :style="
          getTheme() == 'dark'
            ? 'background-color: #505050'
            : 'background-color: white; border-bottom: 1px solid lightgray'
        "
        :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
        class="title font-weight-regular"
      >
        <v-icon
          :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
          class="mr-3"
          medium
          >{{ icon }}</v-icon
        >
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn
          text
          :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
          fab
          small
          @click="clickCancel"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pb-0 pt-4">
        <div class="mb-2">
          <slot></slot>
        </div>
        <v-textarea
          class="ma-0 pa-0"
          outlined
          clearable
          :label="$t('homeMenuCartInfoSendEmailTitle')"
          v-model="msg"
        ></v-textarea>
      </v-card-text>
      <v-card-actions
        :class="getTheme() == 'dark' ? '#505050--text' : '#505050--text'"
        :style="
          getTheme() == 'dark'
            ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
            : 'background-color: white; border-top: 1px solid lightgray;'
        "
      >
        <v-spacer></v-spacer>
        <v-btn @click="clickCancel" text color="primary" class="mr-6">
          {{ $t("addEditFormCancelButton") }}
        </v-btn>
        <v-btn @click="clickAdd" color="primary" dark>
          <v-icon medium class="mr-1">{{ addBtnIcon }}</v-icon>
          {{ addBtnText }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "dialog-send-msg",
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    addBtnIcon: {
      type: String,
      required: true,
    },
    addBtnText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      msg: "",
    };
  },
  methods: {
    clickAdd: function () {
      this.$emit("clickAdd", this.msg);
      this.msg = "";
    },
    clickCancel: function () {
      this.$emit("clickCancel");
    },
  },
};
</script>

<style scoped>
</style>